import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { FastAPIService } from 'src/app/service/fast-api.service';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent implements OnInit{
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if(this.search_input_focus){
      if(event.key === "Tab" && this.search_result_active > -1){
        this.onTabClick(this.suggestions[this.search_result_active]);
      }
      if(event.key === "Enter"){
        if(this.search_result_active == -1)
          this.onSearchClick();
        else
          this.onResultClick(this.suggestions[this.search_result_active]);
      }
      if(event.key === "ArrowDown"){
        this.search_result_active = Math.min(this.suggestions.length - 1, this.search_result_active + 1);
      }
      if(event.key === "ArrowUp"){
        this.search_result_active = Math.max(0, this.search_result_active - 1);
      }
    }
  }

  image_path = "assets/search-box-component-images/";

  search_icon_1 = this.image_path + "search-icon-1.svg";
  search_button_icon = this.image_path + "search-button-icon.svg";
  search_button_active_icon = this.image_path + "search-button-active-icon.svg";
  voice_search_button_icon = this.image_path + "voice-search-button-icon.svg";
  line_icon = this.image_path + "line.png";
  cross_icon = this.image_path + "cross-icon.svg";
  search_result_icon = this.image_path + "search-result-guess-icon.svg";
  search_result_focus_icon = this.image_path + "search-result-guess-focus-icon.svg";
  search_history_icon = this.image_path + "search-history-icon.png";
  enter_icon = this.image_path + "enter-icon.svg";
  meta_select_icon = this.image_path + "select.svg";
  meta_open_icon = this.image_path + "open.svg";
  meta_newtab_icon = this.image_path + "openIn.svg";

  suggestions: string[] = [];


  
  search_input_focus: boolean = false;
  search_result_active: number = -1;

  constructor(private service: FastAPIService) {}

  @Input() search_input: FormControl = new FormControl("");
  @Input() showBackButton: boolean = false;
  @Input() width = "0";
  @Input() top = "0";
  @Input() left = "0"

  @Output() onSearch: EventEmitter<any> = new EventEmitter();
  @Output() onAiSearch: EventEmitter<any> = new EventEmitter();
  @Output() onBackButtonClick: EventEmitter<any> = new EventEmitter();

  @ViewChild('searchInput', { static: false }) search_input_element!: ElementRef;
  currentSearchText:string | undefined
  ngOnInit(): void {
    this.search_input.valueChanges.subscribe(async (input: string) => {
      if (input.trim() === '') {
        this.suggestions = [];
        return;
      }
      const text = input.split(' ');
      this.currentSearchText = input
      const lastText = text[text.length - 1];
      if (lastText === '') {
        this.suggestions = [];
        return;
      }
      const response = await lastValueFrom(this.service.getAutocomplete(lastText));
      this.search_result_active = -1;
      if(response.status == "error")  return;
      const data: any[] = response.data
      this.suggestions = [];
      for(let suggestion of data) {
        this.suggestions.push(suggestion.question)
      }
    });
    document.addEventListener('keydown', this.preventTab);    
  }

  preventTab(e: KeyboardEvent) {
    if (e.key === "Tab") {
      e.preventDefault()

    }
  }

  onClearClick(event: MouseEvent){
    this.suggestions = [];
    event.preventDefault();
    this.search_input.setValue("");
  }

  onSearchClick(){
    if(this.search_input.value == null || this.search_input.value.length <= 0) return;
    this.search_input_element.nativeElement.blur();
    this.onSearch.emit(this.search_input.value.trim());
  }

  onAiSearchClick(){
    if(this.search_input.value == null || this.search_input.value.length <= 0) return;
    this.search_input_element.nativeElement.blur();
    this.onAiSearch.emit(this.search_input.value.trim());
  }

  onResultSuggestionClick(result: string){
    let text = "";
    const temp: string[] = this.search_input.value.split(' ');
    /*for(let i = 0; i < temp.length - 1; i++){
      text += temp[i] + ' ';
    }*/
    temp[temp.length - 1] = result + ' '
    text = temp.join(' ')
    this.search_input.setValue(text);
    this.search_input_element.nativeElement.focus();
    this.search_input_focus = true;

    //this.onSearchClick();
  }

  onInputFocus(){
    this.search_input_focus = true;
    this.search_result_active = -1;
  }

  onInputBlur(){
    this.search_input_focus = false;
    this.search_result_active = -1;
  }

  onResultHover(index: number){
    this.search_result_active = index;
  }

  onResultLeave(){
    this.search_result_active = -1;
  }

  onResultClick(result: string){
    let text = "";
    const temp: string[] = this.search_input.value.split(' ');
    /*for(let i = 0; i < temp.length - 1; i++){
      text += temp[i] + ' ';
    }*/
    text += result + ' ';
    this.search_input.setValue(text);
    this.search_input_element.nativeElement.focus();
    this.search_input_focus = true;

    // this.onSearchClick();
    this.search_result_active = -1;
    this.suggestions = [];
  }

  onTabClick(result: string){
    let text = "";
    const temp: string[] = this.search_input.value.split(' ');
    for(let i = 0; i < temp.length - 1; i++){
      text += temp[i] + ' ';
    }
    text += result + ' ';
    this.search_input.setValue(text);
    this.search_input_element.nativeElement.focus();
    this.search_input_focus = true;
  }

  preventBlur(event: any) {
    event.preventDefault();
  }

  getSearchButtonIcon() {
    if(this.search_input_focus) {
      return this.search_button_active_icon;
    }
    else {
      return this.search_button_icon;
    }
  }

  getSearchResultIcon(index: number) {
    if(index == this.search_result_active) {
      return this.search_result_focus_icon;
    }
    else {
      return this.search_result_icon;
    }
  }
}

//Will be change with other class
export class SearchResult{
  icon: string = "";
  topic: string = "";
  detail: string = "";
  link: string = "";
  date: string = "";
  image: string = "";
  location: string[] | null = null;

  constructor(topic: string, detail: string, link: string, date: string, image: string, location: string[] | null){
    this.topic = topic;
    this.detail = detail;
    this.link = link;
    this.date = date;
    this.image = image;
    this.location = location;
  }
}
